module.exports = __webpack_public_path__ + "static/giraffeanimal4-d8d954c9a83b0fe6e6b941f5a3628542.png";